import _sfc_main from './src/switch.vue2.mjs';
export { switchEmits, switchProps } from './src/switch.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElSwitch = withInstall(_sfc_main);

export { ElSwitch, ElSwitch as default };
//# sourceMappingURL=index.mjs.map
